import axiosConfig from '../modules/axiosConfig'
import utils from '../modules/utils'

const HTTP = axiosConfig.HTTP

const state = {
  registrosMovimientos: '',
  loading: false,
  error: '',
  errorDescription: '',
  codcom: '',
  totalRegistros: 0,
  avanzar: 'false',
  retroceder: 'false',
  indMasDatos: 'N',
  claveInicio: '',
  claveFin: '',
  pantPagina: 0
}

// getters
const getters = {
  getlistMovimientosData: state => state.registrosMovimientos,
  getTotalMovimientosRegistros: state => state.totalRegistros,
  getCodcom: state => state.codcom,
  getAvanzar: state => state.avanzar,
  getRetroceder: state => state.retroceder,
  getIndMasDatos: state => state.indMasDatos,
  getClaveInicio: state => state.claveInicio,
  getClaveFin: state => state.claveFin,
  getPantPagina: state => state.pantPagina
}

// actions
const actions = {
  async listMovimientos ({ commit, rootState }, params) {
    const config = rootState.appConfig.configFile
    try {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const storageAppToken = sessionStorage.getItem('token')
      const hashToken = utils.SHA256(storageAppData.entidad + storageAppToken + storageAppData.canal)
      let body = {}
      body = Object.assign({}, {
        runService: {
          opData: {
            avanzar: params.avanzar ? params.avanzar : false,
            businesstimeout: '',
            canal: storageAppData.canal,
            claveFin: params.claveFin ? params.claveFin : '',
            claveInicio: params.claveInicio ? params.claveInicio : '',
            entidad: storageAppData.entidad,
            idioma: 'ES',
            indMasDatos: 'N',
            oficina: '0001',
            pantPagina: '',
            retroceder: params.retroceder ? params.retroceder : false,
            mainUser: storageAppData.mainUser,
            securityToken: hashToken
          },
          eEntrada: {
            codcom: params.codcom ? params.codcom : ''
          }
        }
      })
      commit('LISTMOVIMIENTOSREQUEST_STARTED', true)
      const response = await HTTP.post(config.endpoints.listMovimientos, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      if (response.status === 200) {
        switch (response.data.runServiceResponse.return.retorno) {
          case '000':
            return response.data.runServiceResponse.return

          case 210:
            return []

          case 102:
            return []

          case 200:
            return false

          default:
            commit('HANDLE_ERROR', response.data.runServiceResponse.return.retorno, { root: true })
            return false
        }
      }
    } catch (error) {
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },

  loader ({ commit }, actions) {
    commit('SET_LOADER', actions)
  }
}

// mutations
const mutations = {
  'SET_LOADER' (state, actions) {
    state.loading = actions.loader === true
    state.isPasswordText = actions.password === true
  },
  'LISTMOVIMIENTOSREQUEST_STARTED' (state, payload) {
    state.loading = payload
  },
  'LISTMOVIMIENTOS_REQUEST_FINISHED' (state, payload) {
    state.loading = payload
  },
  'LISTMOVIMIENTOS_REQUEST_SUCCEED' (state, payload) {
    const datos = payload
    state.error = false
    state.errorDescription = ''
    state.avanzar = datos.avanzar
    state.retroceder = datos.retroceder
    state.indMasDatos = datos.indMasDatos
    state.claveInicio = datos.claveInicio
    state.claveFin = datos.claveFin
    state.pantPagina = datos.pantPagina
    state.registrosMovimientos = datos.totalRegistros > 1 ? datos.registros : Array(datos.registros)
    state.codcom = state.registrosMovimientos[0].codcom
  },
  'LISTMOVIMIENTOS_REQUEST_FAILED' (state, payload) {
    var error
    if (payload.retorno === 200) {
      state.errorDescription = 'Error ejecución de servicio'
    } else if (payload.retorno === 220) {
      state.errorDescription = 'Error técnico'
    } else if (payload.retorno === '039') {
      state.errorDescription = 'Sesión Expirada'
    } else if (payload.retorno === 102) {
      state.errorDescription = 'No se encontraron datos para los criterios de selección'
    }
    state.error = true
    state.registrosMovimientos = ''
    return error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
